import { render, staticRenderFns } from "./Terminals.vue?vue&type=template&id=84cb3540&scoped=true&"
import script from "./Terminals.vue?vue&type=script&lang=ts&"
export * from "./Terminals.vue?vue&type=script&lang=ts&"
import style0 from "./Terminals.vue?vue&type=style&index=0&id=84cb3540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cb3540",
  null
  
)

export default component.exports